import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AlertDialogService {
  dialogRef!: MatDialogRef<AlertDialogComponent>;

  constructor(
    private dialog: MatDialog
  ) { }

  open(mensaje: string){
    this.dialogRef = this.dialog.open(AlertDialogComponent, {
      // width: '250px',
      data: mensaje,
    });
  }

  closed(): Observable<any> {
    return this.dialogRef.afterClosed().pipe(take(1), map((res) => {
      return res;
    }))
    // .subscribe((result) => {
    //   // console.log(`Dialog result: ${result}`);
    //   if(result){
    //     // this.submitForm();
    //   }
    // });
  }
}
